const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid #1a5c2a', fontFamily:"'Georgia', serif", color:'#0a1f0e', lineHeight:'1.7', background:'#f2faf4' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2e8b47', paddingBottom:'8px', marginBottom:'24px', color:'#145a24' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#1e7a36', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2e8b47', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#e8f5ec', border:'2px solid #2e8b47', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#145a24', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2e8b47' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#1e7a36', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#edf7f0' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#145a24', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f4fbf6', border:'1px solid #b6dfc0', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#145a24', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#3a7a4a', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Details</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Penetrating vs Film-Forming Cross-Section ────────────
function DiagramPenetrationCrossSection() {
  const W = 960, H = 400;
  // Layout: left panel 0–460, right panel 490–960
  const panels = [
    {
      x: 10, w: 440,
      title: 'Penetrating Finish',
      subtitle: '(Oil, wax, Danish oil)',
      col: '#c0392b',
      bg: '#fff5f0',
    },
    {
      x: 510, w: 440,
      title: 'Film-Forming Finish',
      subtitle: '(Lacquer, varnish, polyurethane)',
      col: '#1565c0',
      bg: '#f0f4ff',
    },
  ];

  // Wood grain colours for layers
  const woodLayers = [
    { label: 'Cuticle / surface cells', h: 18, fill: '#d4a76a', stroke: '#a07840' },
    { label: 'Earlywood (open grain)', h: 32, fill: '#c8944a', stroke: '#906030' },
    { label: 'Latewood (dense grain)', h: 24, fill: '#b07838', stroke: '#805020' },
    { label: 'Sub-surface cells',       h: 28, fill: '#a06830', stroke: '#704018' },
    { label: 'Deep wood structure',     h: 36, fill: '#906025', stroke: '#603010' },
  ];

  const woodTopY = 92;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Wood Finish Type — Penetrating vs Film-Forming Cross-Section</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="crossArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#546e7a"/>
          </marker>
          {/* Wood grain pattern */}
          <pattern id="grain" x="0" y="0" width="40" height="8" patternUnits="userSpaceOnUse">
            <path d="M0,4 Q10,1 20,4 Q30,7 40,4" fill="none" stroke="#a07840" strokeWidth="0.5" opacity="0.4"/>
          </pattern>
        </defs>

        {panels.map(({ x, w, title, subtitle, col, bg }, pi) => {
          const cx = x + w / 2;
          // Annotate right side of each panel
          const annotX = pi === 0 ? x + w - 4 : x + 4;
          const annotAnchor = pi === 0 ? 'end' : 'start';

          // Cumulative y for wood layers
          let layerY = woodTopY;

          return (
            <g key={pi}>
              {/* Panel background */}
              <rect x={x} y={8} width={w} height={H - 20} rx={6} fill={bg} stroke={col} strokeWidth="1.5"/>
              <text x={cx} y={28} textAnchor="middle" fontSize="13" fill={col} fontWeight="700">{title}</text>
              <text x={cx} y={44} textAnchor="middle" fontSize="10" fill="#555">{subtitle}</text>

              {/* Finish layer on top — different for each type */}
              {pi === 0 ? (
                // Penetrating: thin layer, colour bleeds into wood
                <g>
                  <rect x={x + 30} y={woodTopY - 8} width={w - 60} height={8} rx={2}
                        fill={col} opacity="0.15" stroke={col} strokeWidth="0.5" strokeDasharray="3,2"/>
                  <text x={cx} y={woodTopY - 10} textAnchor="middle" fontSize="9" fill={col}>
                    no surface film — oil absorbed into grain
                  </text>
                </g>
              ) : (
                // Film-forming: solid film above wood
                <g>
                  <rect x={x + 30} y={woodTopY - 28} width={w - 60} height={22} rx={3}
                        fill={col} opacity="0.25" stroke={col} strokeWidth="1.2"/>
                  <text x={cx} y={woodTopY - 14} textAnchor="middle" fontSize="9" fill={col} fontWeight="700">
                    protective film (20–200 µm)
                  </text>
                  {/* Sheen line on top of film */}
                  <line x1={x+30} y1={woodTopY-28} x2={x+w-30} y2={woodTopY-28}
                        stroke="#fff" strokeWidth="3" opacity="0.7"/>
                </g>
              )}

              {/* Wood layers */}
              {woodLayers.map(({ label, h, fill, stroke }, li) => {
                const gy = layerY;
                layerY += h;
                // For penetrating finish, colour the top 2 layers with finish tint
                const tint = (pi === 0 && li < 3) ? col : null;
                return (
                  <g key={li}>
                    <rect x={x + 30} y={gy} width={w - 60} height={h}
                          fill={fill} stroke={stroke} strokeWidth="0.5"/>
                    {/* Grain pattern overlay */}
                    <rect x={x + 30} y={gy} width={w - 60} height={h}
                          fill="url(#grain)" opacity="0.3"/>
                    {/* Finish penetration highlight */}
                    {tint && (
                      <rect x={x + 30} y={gy} width={w - 60} height={h}
                            fill={tint} opacity={0.12 - li * 0.03}/>
                    )}
                    {/* Layer label */}
                    <text x={cx} y={gy + h/2 + 4} textAnchor="middle" fontSize="8.5" fill="#fff" opacity="0.9">{label}</text>
                  </g>
                );
              })}

              {/* Penetration depth indicator for oil */}
              {pi === 0 && (
                <g>
                  <line x1={x + 28} y1={woodTopY} x2={x + 28} y2={woodTopY + woodLayers[0].h + woodLayers[1].h + woodLayers[2].h}
                        stroke={col} strokeWidth="1.5" markerEnd="url(#crossArr)" strokeDasharray="3,2"/>
                  <text x={x + 20} y={woodTopY + 40} textAnchor="end" fontSize="8" fill={col} fontWeight="700">penetrates</text>
                  <text x={x + 20} y={woodTopY + 52} textAnchor="end" fontSize="8" fill={col} fontWeight="700">50–200 µm</text>
                </g>
              )}

              {/* Properties summary box */}
              {(()=>{
                const sumY = woodTopY + woodLayers.reduce((s, l) => s + l.h, 0) + 10;
                const props = pi === 0
                  ? ['✔ Enhances natural feel & colour','✔ Easy to repair — reapply locally','✔ Low build — no surface film','✗ Less water/chemical resistance','✗ Requires more frequent renewal']
                  : ['✔ High water & chemical resistance','✔ Durable surface — hardwearing','✔ Wide gloss range achievable','✗ Must strip / sand to repair','✗ Can peel or crack if flexed'];
                return (
                  <g>
                    <rect x={x + 30} y={sumY} width={w - 60} height={props.length * 16 + 10} rx={3}
                          fill="#fff" stroke={col} strokeWidth="1" opacity="0.9"/>
                    {props.map((p, pi2) => (
                      <text key={pi2} x={x + 36} y={sumY + 14 + pi2 * 16} fontSize="9" fill={p.startsWith('✔') ? '#1e7a36' : '#c0392b'}>{p}</text>
                    ))}
                  </g>
                );
              })()}
            </g>
          );
        })}

        {/* Centre divider label */}
        <text x={W/2} y={H/2 - 10} textAnchor="middle" fontSize="20" fill="#b6dfc0">↔</text>
        <text x={W/2} y={H/2 + 6}  textAnchor="middle" fontSize="8" fill="#546e7a">choose</text>
        <text x={W/2} y={H/2 + 17} textAnchor="middle" fontSize="8" fill="#546e7a">by use</text>
      </svg>
      <div style={S.dCaption}>Penetrating finishes (oils, waxes) are absorbed into the wood fibres, enhancing colour and feel while leaving little or no surface film. They are easy to refresh but offer limited protection. Film-forming finishes (lacquers, varnishes, polyurethane) build a hard layer above the wood surface that provides excellent moisture and chemical resistance but must be stripped to repair and can peel if adhesion fails.</div>
    </div>
  );
}

// ── Diagram 2: Finish Type Comparison — Attribute Bars ──────────────
function DiagramFinishComparison() {
  const W = 960, H = 460;

  const finishes = [
    { name: 'Shellac',        col: '#c0392b', durability:4, waterRes:3, chemRes:2, repairability:9, dryTime:9, voc:5, gloss:8, cost:4 },
    { name: 'Nitrocellulose\nLacquer', col: '#e07b00', durability:5, waterRes:5, chemRes:4, repairability:8, dryTime:9, voc:3, gloss:9, cost:6 },
    { name: 'Alkyd Varnish',  col: '#d4ac0d', durability:7, waterRes:7, chemRes:6, repairability:5, dryTime:4, voc:5, gloss:8, cost:6 },
    { name: 'Oil-based PU',   col: '#1e7a36', durability:9, waterRes:9, chemRes:8, repairability:3, dryTime:3, voc:4, gloss:9, cost:7 },
    { name: 'Water-based PU', col: '#1565c0', durability:8, waterRes:8, chemRes:7, repairability:4, dryTime:7, voc:8, gloss:7, cost:8 },
    { name: 'Danish Oil',     col: '#8e44ad', durability:5, waterRes:5, chemRes:4, repairability:9, dryTime:4, voc:5, gloss:3, cost:7 },
    { name: 'Tung Oil',       col: '#78909c', durability:6, waterRes:6, chemRes:5, repairability:9, dryTime:3, voc:6, gloss:3, cost:5 },
    { name: 'Wax',            col: '#546e7a', durability:3, waterRes:3, chemRes:2, repairability:10, dryTime:8, voc:7, gloss:4, cost:8 },
    { name: 'Conversion\nVarnish', col: '#2e7d32', durability:10, waterRes:10, chemRes:10, repairability:2, dryTime:8, voc:3, gloss:9, cost:5 },
    { name: 'Epoxy',          col: '#6d4c41', durability:10, waterRes:10, chemRes:10, repairability:1, dryTime:5, voc:6, gloss:8, cost:4 },
  ];

  const attrs = [
    { key:'durability',    label:'Durability',       note:'abrasion resistance' },
    { key:'waterRes',      label:'Water resistance',  note:'moisture barrier' },
    { key:'chemRes',       label:'Chem. resistance',  note:'acids, solvents' },
    { key:'repairability', label:'Repairability',     note:'spot repair ease' },
    { key:'dryTime',       label:'Dry / cure speed',  note:'time to recoat' },
    { key:'voc',           label:'Env. friendliness', note:'low VOC = better' },
    { key:'gloss',         label:'Max gloss level',   note:'achievable sheen' },
    { key:'cost',          label:'Cost efficiency',   note:'10 = most economic' },
  ];

  const leftW   = 220;  // finish name column
  const attrW   = (W - leftW - 20) / attrs.length;  // width per attribute column
  const rowH    = 36;
  const headerH = 64;
  const maxScore = 10;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Wood Finish Types — Multi-Attribute Performance Comparison (score 1–10)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Header row */}
        <rect x={0} y={0} width={W} height={headerH} fill="#1e7a36" rx={0}/>
        <text x={leftW/2} y={28} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">Finish Type</text>
        {attrs.map(({ label, note }, ai) => {
          const ax = leftW + ai * attrW + attrW / 2;
          return (
            <g key={ai}>
              <text x={ax} y={22} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">{label}</text>
              <text x={ax} y={36} textAnchor="middle" fontSize="8.5" fill="#c6efce" fontStyle="italic">{note}</text>
              {/* Scale 0–10 label */}
              <text x={ax} y={52} textAnchor="middle" fontSize="8" fill="#a8d5b0">0 ────── 10</text>
            </g>
          );
        })}

        {/* Data rows */}
        {finishes.map((fin, fi) => {
          const ry = headerH + fi * rowH;
          const bg = fi % 2 === 0 ? '#f4fbf6' : '#fff';
          // Wrap name
          const nameParts = fin.name.split('\n');
          return (
            <g key={fi}>
              <rect x={0} y={ry} width={W} height={rowH} fill={bg} stroke="#b6dfc0" strokeWidth="0.5"/>
              {/* Colour swatch + name */}
              <rect x={6} y={ry + 8} width={10} height={rowH - 16} rx={2} fill={fin.col}/>
              {nameParts.map((np, ni) => (
                <text key={ni} x={24} y={ry + 16 + ni * 14 + (nameParts.length === 1 ? 4 : 0)}
                      fontSize="10.5" fill="#145a24" fontWeight="600">{np}</text>
              ))}
              {/* Attribute bars */}
              {attrs.map(({ key }, ai) => {
                const score = fin[key];
                const ax = leftW + ai * attrW;
                const barMaxW = attrW - 8;
                const barW2 = (score / maxScore) * barMaxW;
                // Colour bar by score
                const barCol = score >= 8 ? '#1e7a36' : score >= 5 ? '#e07b00' : '#c0392b';
                return (
                  <g key={ai}>
                    {/* Background track */}
                    <rect x={ax + 4} y={ry + rowH*0.3} width={barMaxW} height={rowH*0.4}
                          rx={3} fill="#e8f5ec" stroke="#b6dfc0" strokeWidth="0.5"/>
                    {/* Score bar */}
                    <rect x={ax + 4} y={ry + rowH*0.3} width={barW2} height={rowH*0.4}
                          rx={3} fill={barCol} opacity="0.82"/>
                    {/* Score label */}
                    <text x={ax + 4 + barW2 + 2} y={ry + rowH*0.3 + rowH*0.25}
                          fontSize="8" fill="#333" fontWeight="700">{score}</text>
                  </g>
                );
              })}
            </g>
          );
        })}

        {/* Legend */}
        {[['#1e7a36','8–10: Excellent'],['#e07b00','5–7: Good'],['#c0392b','1–4: Limited']].map(([col, lbl], li) => (
          <g key={li}>
            <rect x={leftW + li * 160 + 4} y={headerH + finishes.length * rowH + 8}
                  width={12} height={10} fill={col} rx={2}/>
            <text x={leftW + li * 160 + 20} y={headerH + finishes.length * rowH + 17}
                  fontSize="9.5" fill="#333">{lbl}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Performance scores are relative (1–10) and represent typical values under standard interior use conditions. Oil-based polyurethane and conversion varnish lead on durability and chemical resistance; shellac and oils lead on repairability. Water-based polyurethane offers the best balance of durability, low VOC, and recoat speed for industrial furniture production. Cost efficiency scores favour wax and Danish oil for low-build applications.</div>
    </div>
  );
}

// ── Diagram 3: Curing / Drying Mechanisms ───────────────────────────
function DiagramCuringMechanisms() {
  const W = 960, H = 380;

  const mechanisms = [
    {
      title: 'Evaporation',
      subtitle: '(Shellac, lacquer)',
      col: '#c0392b', bg: '#fff5f0',
      steps: ['Solvent evaporates into air','Resin chains deposit on surface','No chemical change — remains re-soluble','Fast: dry in 15–30 min'],
      finishes: ['Shellac','Nitro lacquer','Acrylic lacquer'],
      icon: '💨',
    },
    {
      title: 'Oxidative Polymerisation',
      subtitle: '(Oils, alkyd varnish)',
      col: '#e07b00', bg: '#fff8f0',
      steps: ['Oxygen from air reacts with double bonds','Cross-links form between oil molecules','Irreversible — cannot re-dissolve','Slow: 6–48 h; heat accelerates'],
      finishes: ['Linseed oil','Tung oil','Alkyd varnish','Danish oil'],
      icon: '🔗',
    },
    {
      title: 'Acid / Catalytic Cure',
      subtitle: '(Conversion varnish, pre-cat lacquer)',
      col: '#1565c0', bg: '#f0f4ff',
      steps: ['Acid catalyst triggers cross-linking','Resin + cross-linker form dense network','Very hard, chemical-resistant film','Pot life: 4–8 h after mixing'],
      finishes: ['Conversion varnish','Pre-cat lacquer','Post-cat lacquer'],
      icon: '⚗️',
    },
    {
      title: 'Co-reactant Cure',
      subtitle: '(2-component polyurethane, epoxy)',
      col: '#1e7a36', bg: '#f0fff4',
      steps: ['Part A (resin) + Part B (hardener)','Exothermic cross-linking reaction','Extremely hard, chemically inert film','Pot life: 30 min–4 h; no re-entry until cured'],
      finishes: ['2K polyurethane','Epoxy resin','2K acid-cure lacquer'],
      icon: '🧪',
    },
    {
      title: 'Coalescence',
      subtitle: '(Water-based finishes)',
      col: '#546e7a', bg: '#f5f5f5',
      steps: ['Water evaporates from dispersion','Polymer particles fuse together','Coalescent solvents aid film formation','Cure completes in 1–4 weeks fully'],
      finishes: ['Water-based PU','Water-based acrylic','Waterborne alkyd'],
      icon: '💧',
    },
  ];

  const panelW = (W - 20) / mechanisms.length;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Wood Finish Curing &amp; Drying Mechanisms</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {mechanisms.map(({ title, subtitle, col, bg, steps, finishes, icon }, mi) => {
          const px = 10 + mi * panelW;
          const pw = panelW - 8;
          const cx = px + pw / 2;
          const ph = H - 20;
          return (
            <g key={mi}>
              <rect x={px} y={10} width={pw} height={ph} rx={5} fill={bg} stroke={col} strokeWidth="1.5"/>
              {/* Icon */}
              <text x={cx} y={40} textAnchor="middle" fontSize="20">{icon}</text>
              {/* Title */}
              <text x={cx} y={60} textAnchor="middle" fontSize="11" fill={col} fontWeight="700">{title}</text>
              <text x={cx} y={74} textAnchor="middle" fontSize="8.5" fill="#555">{subtitle}</text>

              {/* Step-by-step */}
              {steps.map((step, si) => (
                <g key={si}>
                  <circle cx={px + 14} cy={94 + si * 36} r={8} fill={col} opacity="0.85"/>
                  <text x={px + 14} y={98 + si * 36} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">{si+1}</text>
                  {/* Step text — word wrap at ~22 chars */}
                  {(()=>{
                    const words = step.split(' ');
                    const lines = [];
                    let line = '';
                    for (const w of words) {
                      if (line && (line + ' ' + w).length > 22) { lines.push(line); line = w; }
                      else { line = line ? line + ' ' + w : w; }
                    }
                    if (line) lines.push(line);
                    return lines.slice(0,3).map((l, li) => (
                      <text key={li} x={px + 26} y={90 + si * 36 + li * 12} fontSize="8.5" fill="#333">{l}</text>
                    ));
                  })()}
                </g>
              ))}

              {/* Separator */}
              <line x1={px + 8} y1={246} x2={px + pw - 8} y2={246} stroke={col} strokeWidth="0.8" strokeDasharray="3,2"/>

              {/* Finish examples */}
              <text x={cx} y={260} textAnchor="middle" fontSize="9" fill={col} fontWeight="700">Finish types:</text>
              {finishes.map((f, fi) => (
                <text key={fi} x={cx} y={274 + fi * 14} textAnchor="middle" fontSize="8.5" fill="#444">{f}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>The curing mechanism determines the fundamental character of a finish: re-solubility, pot life, chemical resistance, and cure time. Evaporative finishes like shellac and lacquer remain soluble in their original solvent — an advantage for repairs but a limitation for chemical resistance. Co-reactant cures (2K PU, epoxy) produce the hardest, most chemically inert films but generate hazardous isocyanates requiring PPE and exhaust ventilation in spray booths.</div>
    </div>
  );
}

// ── Diagram 4: Application Methods ──────────────────────────────────
function DiagramApplicationMethods() {
  const W = 960, H = 430;
  // Four method panels side by side
  const methods = [
    {
      name: 'Spray Application',
      sub: 'HVLP / conventional / airless',
      col: '#1565c0',
      bg: '#f0f4ff',
      pros: ['Even film thickness','Fast — high productivity','All finish types'],
      cons: ['High overspray waste','Requires booth + LEV','Skill needed'],
      transEff: '65–90%',
    },
    {
      name: 'Brush / Pad',
      sub: 'Natural bristle / foam / lambswool',
      col: '#1e7a36',
      bg: '#f0fff4',
      pros: ['Low waste','Good penetration','Minimal equipment'],
      cons: ['Brush marks possible','Slow for large areas','Oils/varnishes only'],
      transEff: '95–100%',
    },
    {
      name: 'Roll Coating',
      sub: 'Reverse / direct roll coater',
      col: '#e07b00',
      bg: '#fff8f0',
      pros: ['Very high speed (flat panels)','Consistent film build','Low labour cost'],
      cons: ['Flat surfaces only','High capital cost','Not for thick films'],
      transEff: '95–99%',
    },
    {
      name: 'Wipe / Cloth',
      sub: 'Pad / rag application',
      col: '#546e7a',
      bg: '#f5f5f5',
      pros: ['No equipment needed','Excellent for oils/wax','Fine control on detail'],
      cons: ['Very labour intensive','Low film build per coat','Fire risk (oily rags)'],
      transEff: '99%',
    },
  ];

  const panelW = (W - 20) / methods.length;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Wood Finish Application Methods — Techniques, Pros &amp; Cons</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="appArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#546e7a"/>
          </marker>
        </defs>

        {methods.map(({ name, sub, col, bg, pros, cons, transEff }, mi) => {
          const px = 10 + mi * panelW;
          const pw = panelW - 8;
          const cx = px + pw / 2;

          return (
            <g key={mi}>
              <rect x={px} y={8} width={pw} height={H - 16} rx={5} fill={bg} stroke={col} strokeWidth="1.5"/>

              {/* Method name */}
              <text x={cx} y={30} textAnchor="middle" fontSize="12" fill={col} fontWeight="700">{name}</text>
              <text x={cx} y={44} textAnchor="middle" fontSize="9" fill="#555">{sub}</text>

              {/* SVG illustration per method */}
              {mi === 0 && (
                // Spray gun
                <g>
                  {/* Gun body */}
                  <rect x={cx - 14} y={58} width={28} height={40} rx={4} fill={col} opacity="0.7"/>
                  {/* Nozzle */}
                  <polygon points={`${cx-4},58 ${cx+4},58 ${cx+2},52 ${cx-2},52`} fill={col} opacity="0.9"/>
                  {/* Spray fan */}
                  {[-3,-2,-1,0,1,2,3].map(d => (
                    <line key={d} x1={cx} y1={52} x2={cx + d*10} y2={36}
                          stroke={col} strokeWidth="1" opacity="0.4" strokeDasharray="2,2"/>
                  ))}
                  {/* Handle */}
                  <rect x={cx - 6} y={96} width={12} height={20} rx={3} fill={col} opacity="0.6"/>
                  {/* Workpiece */}
                  <rect x={px+10} y={118} width={pw-20} height={16} rx={2} fill="#c8944a" stroke="#906030" strokeWidth="1"/>
                  <text x={cx} y={145} textAnchor="middle" fontSize="8.5" fill="#546e7a">Transfer eff: {transEff}</text>
                </g>
              )}
              {mi === 1 && (
                // Brush
                <g>
                  {/* Handle */}
                  <rect x={cx-5} y={52} width={10} height={50} rx={3} fill="#c8944a" stroke="#906030" strokeWidth="1"/>
                  {/* Ferrule */}
                  <rect x={cx-7} y={98} width={14} height={8} rx={1} fill="#78909c" stroke="#546e7a" strokeWidth="1"/>
                  {/* Bristles */}
                  {[-3,-2,-1,0,1,2,3].map(d => (
                    <line key={d} x1={cx+d*2} y1={106} x2={cx+d*3} y2={126}
                          stroke={col} strokeWidth="1.5" opacity="0.7"/>
                  ))}
                  {/* Workpiece */}
                  <rect x={px+10} y={126} width={pw-20} height={16} rx={2} fill="#c8944a" stroke="#906030" strokeWidth="1"/>
                  <text x={cx} y={154} textAnchor="middle" fontSize="8.5" fill="#546e7a">Transfer eff: {transEff}</text>
                </g>
              )}
              {mi === 2 && (
                // Roll coater — two rollers
                <g>
                  {/* Top roller */}
                  <ellipse cx={cx} cy={80} rx={28} ry={16} fill={col} opacity="0.7" stroke={col} strokeWidth="1.5"/>
                  <text x={cx} y={84} textAnchor="middle" fontSize="8" fill="#fff">ROLLER</text>
                  {/* Bottom roller (conveyor) */}
                  <ellipse cx={cx} cy={118} rx={28} ry={12} fill="#78909c" opacity="0.5" stroke="#546e7a" strokeWidth="1"/>
                  {/* Workpiece between rollers */}
                  <rect x={px+10} y={126} width={pw-20} height={12} rx={1} fill="#c8944a" stroke="#906030" strokeWidth="1"/>
                  {/* Feed arrows */}
                  <line x1={px+6} y1={130} x2={px+16} y2={130} stroke={col} strokeWidth="1.5" markerEnd="url(#appArr)"/>
                  <line x1={px+pw-6} y1={130} x2={px+pw-16} y2={130} stroke={col} strokeWidth="1.5"/>
                  <text x={cx} y={150} textAnchor="middle" fontSize="8.5" fill="#546e7a">Transfer eff: {transEff}</text>
                </g>
              )}
              {mi === 3 && (
                // Wipe cloth / pad
                <g>
                  {/* Hand */}
                  <ellipse cx={cx} cy={75} rx={20} ry={14} fill="#f5cba7" stroke="#e07b00" strokeWidth="1"/>
                  {/* Cloth */}
                  <rect x={cx-22} y={88} width={44} height={14} rx={3} fill={col} opacity="0.5" stroke={col} strokeWidth="1"/>
                  {/* Wiping motion arrow */}
                  <path d={`M ${cx-18},85 Q ${cx},76 ${cx+18},85`}
                        fill="none" stroke={col} strokeWidth="1.5" strokeDasharray="3,2" markerEnd="url(#appArr)"/>
                  {/* Workpiece */}
                  <rect x={px+10} y={104} width={pw-20} height={14} rx={2} fill="#c8944a" stroke="#906030" strokeWidth="1"/>
                  <text x={cx} y={131} textAnchor="middle" fontSize="8.5" fill="#546e7a">Transfer eff: {transEff}</text>
                </g>
              )}

              {/* Pros section */}
              <rect x={px+6} y={160} width={pw-12} height={pros.length*20+18} rx={3} fill="#e8f5ec" stroke="#2e8b47" strokeWidth="1"/>
              <text x={px+12} y={175} fontSize="9.5" fill="#1e7a36" fontWeight="700">Advantages</text>
              {pros.map((p, pi) => (
                <text key={pi} x={px+12} y={192 + pi*20} fontSize="9" fill="#145a24">✔ {p}</text>
              ))}

              {/* Cons section */}
              <rect x={px+6} y={163 + pros.length*20 + 16} width={pw-12} height={cons.length*20+18} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
              <text x={px+12} y={163 + pros.length*20 + 31} fontSize="9.5" fill="#c0392b" fontWeight="700">Limitations</text>
              {cons.map((c, ci) => (
                <text key={ci} x={px+12} y={163 + pros.length*20 + 48 + ci*20} fontSize="9" fill="#922b21">✗ {c}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Application method selection depends on production volume, part geometry, finish type, and environmental requirements. HVLP (high-volume low-pressure) spray guns dominate industrial finishing due to speed and film uniformity, achieving 65–75% transfer efficiency versus 35–55% for conventional pressure spray. Roll coaters are standard for flat panel production lines (flooring, MDF board, kitchen cabinet carcasses) running at 30–100 m/min.</div>
    </div>
  );
}

// ── Diagram 5: Gloss Scale ────────────────────────────────────────
function DiagramGlossScale() {
  const W = 960, H = 350;
  // Gloss measured in GU (gloss units) at 60°
  const glossLevels = [
    { name:'Dead Matt', gu:[0,5],   finishes:'Chalk paint, flat wax',          col:'#546e7a' },
    { name:'Matt',      gu:[5,15],  finishes:'Flat oil, burnished wax',         col:'#78909c' },
    { name:'Satin',     gu:[20,40], finishes:'Satin varnish, oil PU, Danish oil',col:'#1e7a36' },
    { name:'Semi-gloss',gu:[40,65], finishes:'Semi-gloss PU, satin lacquer',    col:'#1565c0' },
    { name:'Gloss',     gu:[70,85], finishes:'Gloss lacquer, gloss varnish',    col:'#e07b00' },
    { name:'High gloss',gu:[85,99], finishes:'Piano lacquer, UV cure, catalysed',col:'#c0392b' },
  ];

  const cL = 60, cR = 680, cT = 80, cB = 200;
  const cW = cR - cL;
  const maxGU = 100;
  const gx = v => cL + (v / maxGU) * cW;

  // Reflectance simulation arc
  const reflSeed = Array.from({ length: 50 }, (_, i) => i * 2);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Gloss Scale — Gloss Units (GU at 60°) &amp; Finish Types by Sheen Level</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <linearGradient id="glossGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#546e7a" stopOpacity="0.3"/>
            <stop offset="40%" stopColor="#1e7a36" stopOpacity="0.5"/>
            <stop offset="70%" stopColor="#e07b00" stopOpacity="0.7"/>
            <stop offset="100%" stopColor="#c0392b" stopOpacity="0.9"/>
          </linearGradient>
          <marker id="glossArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#333"/>
          </marker>
        </defs>

        {/* Sheen gradient bar */}
        <rect x={cL} y={cT - 28} width={cW} height={24} rx={4} fill="url(#glossGrad)"/>
        {/* Reflective surface simulation — small glint marks denser at high GU */}
        {reflSeed.filter((_, i) => i < 50).map((x, i) => {
          const gxv = cL + x * (cW / 100);
          const density = x / 100;
          return density > Math.random() * 0.8 ? (
            <line key={i} x1={gxv} y1={cT-28} x2={gxv + 2} y2={cT-20}
                  stroke="#fff" strokeWidth="1" opacity={0.3 + density * 0.5}/>
          ) : null;
        })}
        <text x={cL} y={cT - 32} fontSize="9" fill="#546e7a">MATT</text>
        <text x={cR} y={cT - 32} textAnchor="end" fontSize="9" fill="#c0392b">HIGH GLOSS</text>

        {/* Gloss level bars */}
        {glossLevels.map(({ name, gu, finishes, col }, gi) => {
          const rowY = cT + gi * 36;
          const barX1 = gx(gu[0]);
          const barX2 = gx(gu[1]);
          const barW2 = barX2 - barX1;
          return (
            <g key={gi}>
              <rect x={cL} y={rowY} width={cW} height={34} fill={gi%2===0?'#f4fbf6':'#fff'} opacity="0.6"/>
              {/* Level name */}
              <text x={cL - 6} y={rowY + 21} textAnchor="end" fontSize="11" fill="#145a24" fontWeight="700">{name}</text>
              {/* GU range bar */}
              <rect x={barX1} y={rowY + 6} width={barW2} height={22} rx={4} fill={col} opacity="0.75"/>
              {/* GU range labels */}
              <text x={barX1 - 2} y={rowY + 20} textAnchor="end" fontSize="9" fill={col} fontWeight="700">{gu[0]}</text>
              <text x={barX2 + 2} y={rowY + 20} fontSize="9" fill={col} fontWeight="700">{gu[1]}</text>
              {/* Finish examples */}
              <text x={cR + 12} y={rowY + 21} fontSize="10" fill="#444">{finishes}</text>
            </g>
          );
        })}

        {/* X axis */}
        <line x1={cL} y1={cB + 16} x2={cR + 6} y2={cB + 16} stroke="#333" strokeWidth="1.5" markerEnd="url(#glossArr)"/>
        {[0,10,20,30,40,50,60,70,80,90,100].map(v => (
          <g key={v}>
            <line x1={gx(v)} y1={cB+10} x2={gx(v)} y2={cB+18} stroke="#546e7a" strokeWidth="1"/>
            <text x={gx(v)} y={cB+28} textAnchor="middle" fontSize="8.5" fill="#555">{v}</text>
          </g>
        ))}
        <text x={cL + cW/2} y={cB + 40} textAnchor="middle" fontSize="11" fill="#333">Gloss Units (GU) at 60° — ISO 2813</text>

        {/* Measurement method note */}
        <rect x={cL} y={cB + 50} width={cW} height={28} rx={3} fill="#e8f5ec" stroke="#2e8b47" strokeWidth="1"/>
        <text x={cL + 8} y={cB + 62} fontSize="9.5" fill="#145a24" fontWeight="700">Measurement: </text>
        <text x={cL + 88} y={cB + 62} fontSize="9.5" fill="#444">{"Gloss meter at 60° geometry (ISO 2813); 20° for high gloss (>70 GU); 85° for very matt (<10 GU)"}</text>
        <text x={cL + 8} y={cB + 74} fontSize="9.5" fill="#444">Batch specification: typical tolerance ±5 GU for furniture; ±3 GU for automotive / kitchen doors</text>

        {/* Surface simulation panel */}
        <rect x={700} y={cT - 30} width={250} height={H - 50} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={825} y={cT - 12} textAnchor="middle" fontSize="12" fill="#145a24" fontWeight="700">Key Factors</text>
        {[
          { heading:'Resin type',   body:'Nitrocellulose: easy high gloss;\noil PU: max gloss limited by sheen' },
          { heading:'Flatting paste',body:'Silica/wax added to reduce gloss;\nmore paste = lower GU' },
          { heading:'Substrate prep', body:'Sand to P320+ for high gloss;\ncoarser prep = orange peel, lower GU' },
          { heading:'Film build',   body:'Thicker film → higher achievable gloss;\nthin films show substrate texture' },
        ].map(({ heading, body }, i) => {
          const ky = cT + i * 62;
          return (
            <g key={i}>
              <rect x={708} y={ky} width={234} height={56} rx={3}
                    fill={i%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="1"/>
              <text x={716} y={ky+16} fontSize="10.5" fill="#145a24" fontWeight="700">{heading}</text>
              {body.split('\n').map((line, li) => (
                <text key={li} x={716} y={ky+30+li*13} fontSize="9.5" fill="#444">{line}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Gloss is measured in Gloss Units (GU) using a glossmeter at standardised angles per ISO 2813. At 60° geometry, the full range from dead matt to high gloss is covered. Industrial furniture specifications typically define gloss ±5 GU; kitchen doors and automotive interiors require ±3 GU batch consistency. Flatting agents (fine silica or wax particles) scatter light to reduce gloss without changing the underlying chemistry of the finish.</div>
    </div>
  );
}

// ── Diagram 6: Finishing Process Build-Up Sequence ───────────────────
function DiagramFinishBuildUp() {
  const W = 960, H = 400;

  // Three-column: annotation labels left, build-up cross-section centre, right notes panel
  const labelMaxX = 205;
  const secL = 218;
  const secW = 440;
  const secCX = secL + secW / 2;
  const panelX = 675;

  // Layers from bottom to top (drawn bottom-first)
  const buildLayers = [
    { label:'Bare wood (sanded to P180)',      h:52, fill:'#c8944a', textCol:'#fff', note:'Grain raised → re-sand after sealing' },
    { label:'Grain filler / pore filler',      h:16, fill:'#a07840', textCol:'#fff', note:'Fills open grain (oak, ash); sand P240' },
    { label:'Sealer / sanding sealer coat',    h:20, fill:'#8ecfa0', textCol:'#fff', note:'Binds substrate; sand P240–P320' },
    { label:'1st finish coat',                 h:22, fill:'#52b96a', textCol:'#fff', note:'Build coat; sand P320 between coats' },
    { label:'2nd finish coat',                 h:22, fill:'#2e8b47', textCol:'#fff', note:'Build coat; denib P320–P400 wet' },
    { label:'Final / top coat',                h:22, fill:'#1e7a36', textCol:'#fff', note:'Final surface; do not sand unless flatting' },
    { label:'Optional: wax / polishing layer', h:10, fill:'#145a24', textCol:'#fff', note:'Burnish with 0000 steel wool or polishing pad' },
  ];

  // Positions — stack bottom to top (SVG y inverted)
  const totalH = buildLayers.reduce((s, l) => s + l.h, 0);
  const baseY = 50 + totalH + 20;  // bottom of stack

  const annots = buildLayers.map((layer, i) => {
    const prevH = buildLayers.slice(0, i).reduce((s, l) => s + l.h, 0);
    const midY = baseY - prevH - layer.h / 2;
    return { dotY: midY, label: layer.label };
  });

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Finishing Schedule — Layer Build-Up Sequence &amp; Coat Purposes</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <linearGradient id="woodBG" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#d4a76a"/>
            <stop offset="100%" stopColor="#a07840"/>
          </linearGradient>
          <pattern id="woodGrainFine" x="0" y="0" width="30" height="6" patternUnits="userSpaceOnUse">
            <path d="M0,3 Q7,1 15,3 Q22,5 30,3" fill="none" stroke="#906030" strokeWidth="0.4" opacity="0.35"/>
          </pattern>
          <marker id="buildArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#1e7a36"/>
          </marker>
        </defs>

        {/* Left annotation labels */}
        {annots.map(({ dotY, label }, i) => (
          <g key={i}>
            <text x={labelMaxX} y={dotY + 4} textAnchor="end" fontSize="10" fill="#333">{label}</text>
            <line x1={labelMaxX + 4} y1={dotY} x2={secL - 4} y2={dotY}
                  stroke="#546e7a" strokeWidth="1" strokeDasharray="4,3"/>
            <circle cx={secL - 4} cy={dotY} r={3} fill="#546e7a"/>
          </g>
        ))}

        {/* Build-up stack cross-section */}
        {buildLayers.map((layer, i) => {
          const prevH = buildLayers.slice(0, i).reduce((s, l) => s + l.h, 0);
          const gy = baseY - prevH - layer.h;
          return (
            <g key={i}>
              <rect x={secL} y={gy} width={secW} height={layer.h}
                    fill={layer.fill} stroke="#145a24" strokeWidth="0.5"/>
              {/* Grain on wood layer */}
              {i === 0 && (
                <rect x={secL} y={gy} width={secW} height={layer.h} fill="url(#woodGrainFine)"/>
              )}
              <text x={secCX} y={gy + layer.h/2 + 4} textAnchor="middle"
                    fontSize={layer.h < 18 ? '8' : '10'} fill={layer.textCol} fontWeight="600">
                {layer.h >= 14 ? layer.label.split('(')[0].trim() : ''}
              </text>
            </g>
          );
        })}

        {/* Total DFT (dry film thickness) dimension line */}
        {(()=>{
          const filmTop = baseY - totalH + buildLayers[0].h;
          const filmBot = baseY;
          const dx = secL + secW + 20;
          return (
            <g>
              <line x1={dx} y1={filmTop} x2={dx} y2={filmBot}
                    stroke="#1e7a36" strokeWidth="1.5"/>
              <line x1={dx-6} y1={filmTop} x2={dx+6} y2={filmTop} stroke="#1e7a36" strokeWidth="1.5"/>
              <line x1={dx-6} y1={filmBot} x2={dx+6} y2={filmBot} stroke="#1e7a36" strokeWidth="1.5"/>
              <text x={dx+8} y={(filmTop+filmBot)/2-6} fontSize="9" fill="#1e7a36" fontWeight="700">Total</text>
              <text x={dx+8} y={(filmTop+filmBot)/2+6} fontSize="9" fill="#1e7a36" fontWeight="700">DFT</text>
              <text x={dx+8} y={(filmTop+filmBot)/2+18} fontSize="9" fill="#1e7a36">60–200 µm</text>
            </g>
          );
        })()}

        {/* Build arrows on left side */}
        <line x1={secL - 16} y1={baseY} x2={secL - 16} y2={baseY - totalH + 10}
              stroke="#1e7a36" strokeWidth="1.5" markerEnd="url(#buildArr)"/>
        <text x={secL - 24} y={(baseY + baseY - totalH)/2} textAnchor="middle" fontSize="9" fill="#1e7a36"
              transform={`rotate(-90 ${secL-24} ${(baseY + baseY-totalH)/2})`}>build up →</text>

        {/* Right notes panel */}
        <rect x={panelX} y={16} width={276} height={H - 30} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={panelX + 138} y={36} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Coat Notes</text>
        {buildLayers.map((layer, i) => {
          const prevH = buildLayers.slice(0, i).reduce((s, l) => s + l.h, 0);
          const midY = baseY - prevH - layer.h / 2;
          // Map y into right panel space
          const ry = 46 + i * 46;
          return (
            <g key={i}>
              <rect x={panelX + 6} y={ry} width={264} height={40} rx={3}
                    fill={i%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="1"/>
              <rect x={panelX + 8} y={ry + 6} width={6} height={28} rx={2} fill={layer.fill}/>
              <text x={panelX + 20} y={ry + 17} fontSize="9.5" fill="#145a24" fontWeight="700">
                {layer.label.split('(')[0].trim()}
              </text>
              <text x={panelX + 20} y={ry + 32} fontSize="9" fill="#546e7a">{layer.note}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>A professional finish schedule builds from substrate preparation through filling, sealing, and multiple finish coats to an optional topcoat or polish. Each inter-coat sand step removes surface contamination, levels orange peel, and provides mechanical adhesion for the next coat. Total dry film thickness (DFT) for a three-coat spray system typically ranges from 60–120 µm; piano-finish piano lacquer builds to 200–400 µm over many coats with polishing between each.</div>
    </div>
  );
}

// ── Diagram 7: Chemical Resistance & Durability Matrix ───────────────
function DiagramResistanceMatrix() {
  const W = 960, H = 420;

  const finishes = ['Shellac','NC Lacquer','Alkyd Varnish','Oil PU','Water PU','Danish Oil','Conv. Varnish','Epoxy'];
  const tests = [
    'Water (24h)',
    'Ethanol (1h)',
    'Coffee / tea',
    'Citric acid',
    'Acetone (5 min)',
    'Cutting/abrasion',
    'Heat (80°C)',
    'UV / weathering',
  ];

  // Ratings: 3=Excellent, 2=Good, 1=Fair, 0=Poor
  const matrix = [
    // Shellac  NC-Lac  Alkyd  OilPU  WaterPU DanOil  ConvV  Epoxy
    [0,        1,      2,     3,     3,       1,      3,     3],  // Water
    [0,        1,      2,     3,     2,       1,      3,     3],  // Ethanol
    [1,        1,      2,     3,     3,       1,      3,     3],  // Coffee
    [1,        1,      2,     3,     3,       1,      3,     3],  // Citric acid
    [0,        0,      1,     2,     2,       0,      3,     3],  // Acetone
    [1,        2,      2,     3,     3,       1,      3,     3],  // Cutting
    [1,        1,      2,     3,     2,       2,      3,     3],  // Heat
    [2,        1,      2,     2,     3,       2,      2,     1],  // UV
  ];

  const ratingColors = ['#fde8e8','#fff3cd','#d4edda','#c6efce'];
  const ratingText   = ['Poor','Fair','Good','Excellent'];
  const ratingTextCol= ['#c0392b','#8b5c00','#1e7a36','#145a24'];

  const headerH = 70;
  const cellW = (W - 220) / finishes.length;
  const cellH = (H - headerH - 30) / tests.length;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Chemical &amp; Physical Resistance Matrix — Common Wood Finishes</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Column headers — finish names */}
        <rect x={0} y={0} width={W} height={headerH} fill="#1e7a36"/>
        <text x={110} y={headerH/2 + 5} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">Resistance Test</text>
        {finishes.map((f, fi) => (
          <text key={fi} x={220 + fi * cellW + cellW/2} y={headerH/2 - 4}
                textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700"
                transform={`rotate(-30 ${220 + fi * cellW + cellW/2} ${headerH/2 - 4})`}>{f}</text>
        ))}

        {/* Rows */}
        {tests.map((test, ti) => {
          const ry = headerH + ti * cellH;
          return (
            <g key={ti}>
              {/* Row background */}
              <rect x={0} y={ry} width={W} height={cellH} fill={ti%2===0?'#f4fbf6':'#fff'}/>
              {/* Test name */}
              <text x={8} y={ry + cellH/2 + 4} fontSize="10.5" fill="#145a24" fontWeight="600">{test}</text>
              {/* Cells */}
              {matrix[ti].map((rating, fi) => {
                const cx2 = 220 + fi * cellW + cellW/2;
                const cy2 = ry + cellH/2;
                return (
                  <g key={fi}>
                    <rect x={220 + fi * cellW + 2} y={ry + 2} width={cellW - 4} height={cellH - 4}
                          rx={3} fill={ratingColors[rating]} stroke="#b6dfc0" strokeWidth="0.8"/>
                    <text x={cx2} y={cy2 + 4} textAnchor="middle" fontSize="9.5"
                          fill={ratingTextCol[rating]} fontWeight="700">
                      {ratingText[rating]}
                    </text>
                  </g>
                );
              })}
            </g>
          );
        })}

        {/* Legend */}
        {ratingText.map((rt, ri) => (
          <g key={ri}>
            <rect x={220 + ri * 130} y={headerH + tests.length * cellH + 6}
                  width={50} height={16} rx={3} fill={ratingColors[ri]} stroke="#b6dfc0" strokeWidth="0.8"/>
            <text x={274 + ri * 130} y={headerH + tests.length * cellH + 18}
                  fontSize="10" fill={ratingTextCol[ri]} fontWeight="700">{rt}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Chemical resistance testing follows BS EN 12720 (surface resistance to cold liquids) and BS EN 12721 (wet heat resistance). Conversion varnish and epoxy lead across nearly all categories; shellac and NC lacquer are the most vulnerable to solvents and water. For kitchen and bathroom furniture, a minimum rating of "Good" for water and ethanol is typically specified. UV resistance tests use accelerated weathering (Xenon arc, ISO 11341) for exterior or high-exposure applications.</div>
    </div>
  );
}

// ── Main export ────────────────────────────────────────────────────
export default function WoodFinishes() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Types of Wood Finishes — Industrial Engineering</h1>
      <p style={S.p}>
        Wood finishing is the process of applying a protective and decorative coating to wood surfaces. In industrial engineering and furniture manufacturing, finish selection governs the product's durability, appearance, chemical resistance, repairability, and compliance with environmental regulations (VOC limits). Finishes range from natural penetrating oils to high-performance two-component catalysed lacquers, each with distinct chemistry, application requirements, and performance characteristics.
      </p>

      <InfoBox title="Core Concepts at a Glance" items={[
        "Penetrating finishes (oils, wax): absorbed into wood fibres — enhance natural feel, easy repair, lower protection",
        "Film-forming finishes (lacquer, varnish, PU): build a hard layer above the wood — high protection, harder to repair",
        "Curing mechanisms: evaporation (shellac, NC lacquer), oxidative polymerisation (oils, alkyd), acid/catalyst cure (conversion varnish), co-reactant (2K PU, epoxy), coalescence (water-based)",
        "Gloss measured in Gloss Units (GU) at 60° per ISO 2813: 0–10 matt, 20–40 satin, 70–85 gloss, >85 high gloss",
        "DFT (Dry Film Thickness): single spray coat typically 20–40 µm; full system 60–120 µm; piano finish up to 400 µm",
        "VOC (Volatile Organic Compounds): solvent-based finishes 400–700 g/L; water-based 50–200 g/L; compliance with EU Directive 2004/42/EC",
        "Transfer efficiency: HVLP spray 65–75%; airless 50–60%; roll coater 95–99%; brush/wipe ~100%",
        "Conversion varnish and 2K polyurethane: highest durability and chemical resistance for commercial furniture",
        "Sanding between coats with P320–P400 is essential for inter-coat adhesion and surface level",
      ]}/>

      <h2 style={S.h2}>Penetrating vs Film-Forming — Fundamental Classification</h2>
      <p style={S.p}>
        All wood finishes fall into one of two fundamental categories based on how they interact with the wood substrate. Penetrating finishes are absorbed into the open cell structure of the wood, enriching the grain without building a distinct surface layer. Film-forming finishes remain above the surface, creating a continuous protective membrane that separates the wood from its environment.
      </p>
      <DiagramPenetrationCrossSection/>
      <Table2 rows={[
        ["Penetrating finishes","Absorbed 50–200 µm into wood cells; no or minimal surface film\nExamples: linseed oil, tung oil, Danish oil, hard wax oil, beeswax\nAdvantage: natural look and feel, easy spot repair by re-application"],
        ["Film-forming finishes","Build a continuous film of 20–200 µm above the wood surface\nExamples: lacquer, varnish, polyurethane, shellac, epoxy\nAdvantage: high moisture/chemical barrier, wide gloss range"],
        ["Open-grain vs closed-grain","Open-grain woods (oak, ash, walnut) require pore filler before film finishes\nClosed-grain woods (maple, cherry, birch) accept film finishes without filling\nFilling affects appearance: filled pores = smooth; unfilled = textured"],
        ["Adhesion mechanism","Mechanical: finish keys into wood surface texture (sanding provides profile)\nChemical: polar groups in resin bond to wood hydroxyl groups\nPoor adhesion causes delamination — surface prep is critical"],
        ["Film thickness units","WFT (wet film thickness): measured immediately after application\nDFT (dry film thickness): after solvent loss and cure\nDFT = WFT × (volume solids % / 100)  — e.g. 60 µm WFT × 50% = 30 µm DFT"],
      ]}/>

      <h2 style={S.h2}>Finish Types — Performance Comparison</h2>
      <p style={S.p}>
        Industrial finish selection involves trading off multiple competing attributes. No single finish excels in all categories — the optimal choice depends on the use environment, production volume, VOC compliance requirements, and whether the product will need field repairs.
      </p>
      <DiagramFinishComparison/>
      <Table2 rows={[
        ["Shellac","Natural resin secreted by lac insects; dissolved in ethyl alcohol\nExcellent adhesion primer; re-soluble in alcohol — very easy to repair\nNot suitable for wet areas; sensitive to heat and alcohol staining\nCommon grades: dewaxed (best adhesion), orange, blonde, garnet"],
        ["Nitrocellulose lacquer","Fast-drying evaporative finish; re-soluble in solvents\nExcellent spray characteristics; can be buffed to high gloss\nBrittle with age — prone to cracking on flexible substrates\nHigh VOC (~600 g/L); declining in EU industrial use due to regulations"],
        ["Alkyd varnish","Oil-modified alkyd resin; cures by oxidative polymerisation\nGood durability and flexibility; suitable for exterior with UV absorbers added\nYellows over time (unsuitable for white/pale substrates)\nSlow drying (6–24 h between coats); can be brushed or sprayed"],
        ["Oil-based polyurethane","Urethane-modified alkyd or pure urethane; hardest of oil-based finishes\nExcellent abrasion and chemical resistance; can yellow on light wood\n2K (two-component) version: isocyanate hardener — hazardous; excellent durability\n1K (moisture-cure): reacts with atmospheric moisture — limited pot life concerns"],
        ["Water-based polyurethane","Acrylic or urethane dispersion in water; low VOC (50–200 g/L)\nNon-yellowing; fast recoat (1–2 h); raises wood grain on first coat\nSlightly lower chemical resistance than oil-based PU\nPreferred for indoor furniture; standard in kitchen doors, children's products"],
        ["Conversion varnish","Acid-catalysed amino-alkyd or melamine-urea; 2K product with pot life\nHardest, most chemically resistant spray lacquer — industry standard for kitchen carcasses\nHigh cross-link density; cannot be re-dissolved; scratch visible on dark colours\nPot life 4–8 h; force-dry capable (60–80°C oven, 20–30 min)"],
        ["Danish oil / hard wax oil","Blended penetrating oil (linseed + tung + naphtha + mineral spirits)\nEasy wipe-on application; builds in 3–4 coats; warm, natural appearance\nRegular maintenance required (annual re-coat); not suitable for wet surfaces\nHard wax oil (Osmo, RuboLine): similar but harder wax matrix — better water resistance"],
        ["UV-cure coatings","Photo-initiator reacts to UV light; cures in seconds on UV-belt lines\nVery high production speed; zero VOC during cure; hard, consistent film\nRequires UV lamp investment; substrate must be flat (belt conveyor)\nDominant in high-volume flat panel lines (flooring, MDF doors)"],
      ]}/>

      <h2 style={S.h2}>Curing &amp; Drying Mechanisms</h2>
      <p style={S.p}>
        The cure mechanism determines a finish's re-solubility, repairability, pot life constraints, chemical resistance ceiling, and hazardous material considerations. Matching the curing chemistry to the production environment — exhaust ventilation, oven availability, pot life management — is as important as matching finish properties to end-use requirements.
      </p>
      <DiagramCuringMechanisms/>
      <Table2 rows={[
        ["Evaporation (lacquers)","Solvent evaporates; resin deposits; no chemical change — re-soluble\nAdvantage: easy repair and re-coating; fast recoat; reworkable\nDry time: touch dry 10–30 min; recoat 30–60 min at 20°C\nSolvent retention in thick films causes adhesion problems — avoid excessive wet film"],
        ["Oxidative polymerisation","O₂ from air reacts with unsaturated fatty acid chains (linolenic, linoleic)\nCross-link density increases over weeks — full cure in 1–4 weeks\nInhibited by cold temperatures (below 10°C curing nearly stops)\nLinseed oil: fastest oxidiser; tung oil: waterproof, resistant to alkalis"],
        ["Acid catalytic cure","Acid (p-toluene sulphonic acid or maleic acid) triggers aminoplast cross-linking\nPot life 4–8 h after acid addition; discard unused mixed product\nForce-dry at 60–80°C reduces cure time to 20–30 min\nHigh cross-link density: excellent stain resistance; typical for kitchen furniture"],
        ["2K polyurethane cure","Isocyanate (NCO) reacts with polyol (OH) to form urethane linkages\nPot life: 2–4 h at 20°C; recoat when tack-free (~2–4 h)\nIsocyanates are sensitisers — full air-fed RPE + approved spray booth mandatory\nExcellent chemical and abrasion resistance; used in gymnasium floors, bar tops"],
        ["Coalescence (water-based)","Water evaporates; emulsion particles coalesce (fuse) into continuous film\nCoalescent solvent helps particle fusion — residual in film\nFilm formation fails below 5°C (minimum film formation temperature — MFT)\nFull cross-linking (in 2K water-based) takes 1–4 weeks at ambient temperature"],
        ["UV cure","Photo-initiator absorbs UV photons → generates free radicals → rapid polymerisation\nInstantaneous cure (0.1–2 s at 80–200 mW/cm²); 100% solids (zero VOC)\nSubstrate must be UV-transparent or reflect UV sufficiently\nMatting UV finishes require special matting agents with UV-stable chemistry"],
        ["Moisture cure (1K PU)","Atmospheric moisture reacts with isocyanate groups in pre-polymer\nSlow in dry conditions; fast in high humidity — climate control important\nSelf-levelling; used for floor coatings and exterior joinery\nRe-coat window critical: too soon = solvent pop; too late = adhesion loss"],
      ]}/>

      <h2 style={S.h2}>Application Methods</h2>
      <p style={S.p}>
        The application method determines transfer efficiency (proportion of mixed finish reaching the substrate), film uniformity, production speed, and environmental impact. Industrial production lines use spray, roll coating, or curtain coating depending on part geometry and throughput requirements.
      </p>
      <DiagramApplicationMethods/>
      <Table2 rows={[
        ["HVLP spray","High Volume Low Pressure — atomises at 0.3–0.7 bar at air cap\nTransfer efficiency: 65–75% (vs 35–45% conventional)\nIdeal for furniture, cabinetry, mouldings; all solvent and water-based finishes\nCompliant with US SCAQMD Rule 1151; preferred technology in EU regulation"],
        ["Airless spray","High-pressure pump (50–200 bar) forces finish through small orifice\nNo atomising air — less overspray, higher transfer than conventional\nIdeal for high-viscosity coatings (thick varnishes, enamels)\nAtom-less tip produces fan; fan pattern controlled by tip size (spray angle × orifice)"],
        ["Air-assisted airless (AAA)","Combines airless atomisation with low-pressure air shaping\nTransfer efficiency 65–80%; finer finish than pure airless\nUsed for high-build coatings on flat doors and panels"],
        ["Roll coating","Direct or reverse roll coater; industrial machines run at 30–100 m/min\nExcellent consistency; minimal waste (closed trough); suitable for UV and water-based\nLimited to flat panels; film thickness controlled by roll gap and speed ratio\nTypical applications: flooring, kitchen doors, MDF faces, worktops"],
        ["Curtain coating","Continuous curtain of finish falls onto moving substrate\nVery high speed (50–150 m/min); excellent uniformity on flat panels\nStreak-free film; suitable for UV-curable and water-based systems\nLimited to flat workpieces; film weight controlled by curtain head pressure"],
        ["Electrostatic spray","High-voltage field (30–100 kV) charges atomised droplets → attracted to grounded part\nTransfer efficiency: 85–95%; ideal for complex 3D shapes (chair legs, turnings)\nRequires conductive or semi-conductive substrate (wood must be humidified)\nUsed in high-volume chair, cabinet hardware, and architectural joinery production"],
        ["Brushing","Natural bristle (polyester for water-based); cut in with care on mouldings\nVery high transfer; no overspray; suitable for small batches and on-site\nBrush marks can be levelled by subsequent sanding or self-levelling finish additives\nRetarder solvents extend open time; flow additives improve lay-out"],
        ["Dipping / flow coating","Part immersed in or flooded with finish; drains back to tank\nAll surfaces coated including internal; very high transfer (95%+)\nRequires controlled drain time to achieve even film; not for high-gloss applications\nUsed for window frames, turned spindles, mass-produced handles"],
      ]}/>

      <h2 style={S.h2}>Gloss Level Specification</h2>
      <p style={S.p}>
        Gloss level is a primary aesthetic specification for finished wood products and is measured objectively by a reflectometer (glossmeter) per ISO 2813. The choice of gloss level affects perceived quality, surface defect visibility, cleanability, and the type and amount of flatting agent required in the coating formulation.
      </p>
      <DiagramGlossScale/>
      <Table2 rows={[
        ["Gloss measurement","ISO 2813: 60° geometry for mid-range (10–70 GU); 20° for high gloss (>70); 85° for matt (<10)\nReporting: average of 5 readings; standard deviation to assess uniformity\nEquipment: BYK Gardner micro-TRI-gloss; Elcometer 480; Data-Physics GP-32"],
        ["Flatting agents","Precipitated silica (SiO₂): most common; particle size 4–12 µm\nWax combinations (polyethylene, PTFE): improve feel and scratch resistance\nConcentration: 0.5–5% by weight; higher loading = lower GU\nEffect: scatters reflected light; doesn't affect cure chemistry"],
        ["Gloss uniformity","Batch-to-batch: typically ±5 GU for general furniture; ±3 GU for kitchen, automotive\nWithin-panel variation caused by: uneven substrate absorption, non-uniform spray\nMonitor with inline gloss sensors on roll-coating lines for real-time control"],
        ["Sheen levels in practice","Matt (5–15 GU): hides surface defects; easy to retouch; used in interior joinery\nSatin (20–40 GU): most specified for residential furniture — balanced look\nGloss (70–85 GU): shows all substrate defects; maximum hygiene cleanability\nHigh gloss (>85 GU): piano finish, kitchen doors — requires P800+ substrate prep"],
        ["Effect of substrate on gloss","Open grain wood absorbs finish → local gloss reduction (sink-back)\nFilling open grain before top-coating essential for achieving >60 GU\nHigh-density MDF (880 kg/m³) produces best gloss as absorption is minimal"],
        ["Temperature effect","Low temperature (<15°C): coalescence fails in water-based; slow oxidation in oils\nHigh temperature (>30°C): fast drying → solvent pop, orange peel, gloss reduction\nOptimum application conditions: 18–22°C, 45–65% RH for most solvent systems"],
      ]}/>

      <h2 style={S.h2}>Finishing Schedule &amp; Build-Up</h2>
      <p style={S.p}>
        A professional finishing schedule specifies every stage from bare wood preparation through the final top coat. Each stage has a specific function: the sealer creates a uniform, stable base; build coats achieve the required DFT; the top coat delivers the final appearance and primary surface protection. Inter-coat sanding at each stage is critical for adhesion and surface level.
      </p>
      <DiagramFinishBuildUp/>
      <Table2 rows={[
        ["Substrate preparation","Sand bare wood P120 → P180 → P220 in sequence; always with grain\nRaise grain: wipe with damp cloth, allow to dry, then sand P240 to remove raised fibres\nRemove all dust with tack cloth or air blow; check for oil/silicone contamination (fisheye test)"],
        ["Pore / grain filler","Required for open-grain woods (oak, ash, walnut, mahogany) before high-gloss film finishes\nTypes: paste wood filler (shellac-based), water-based acrylic filler, polyester filler\nApplication: force into grain across grain; remove excess; sand P240 when dry"],
        ["Sanding sealer","Purpose: binds wood fibres, seals resin pockets, provides uniform absorbency\nContains zinc stearate (slip agent) for easy sand; sand P240–P320\nNitro sanding sealer dries fastest; shellac as universal sealer under most finishes"],
        ["Build / intermediate coats","Typically 2–3 coats; wet-on-wet or sand between (P320)\nAim: achieve target DFT; fill any remaining texture\nForce-dry between coats (40–60°C, 10–20 min) on conversion varnish production lines"],
        ["Inter-coat sanding","P320 for most systems; P400 wet between final coats on high-gloss\nPurpose: mechanical adhesion, level orange peel, remove contamination\nFull flatting (scuff) required if recoating after full cure — use P180–P240"],
        ["Final / top coat","Applied at lower viscosity; fine spray tip (1.2–1.4 mm) for smooth atomisation\nDo not sand unless flatting for polishing; contamination control critical\nInspect under raking light before passing — rejects at this stage are expensive"],
        ["Polish / burnish","Optional: machine polish with compound + buffer for ultra-high gloss\nPDA (paint defect analysis) includes orange peel rating (ISO 7668) for automotive-grade kitchen doors\nWax polish or ceramic coating applied as final protective and feel layer"],
      ]}/>

      <h2 style={S.h2}>Chemical &amp; Physical Resistance</h2>
      <DiagramResistanceMatrix/>
      <Table2 rows={[
        ["Water resistance (BS EN 12720)","Spot test: distilled water 24 h at 23°C on horizontal surface\nRating 1–5 (5 = no visible change); minimum rating 4 required for kitchen furniture\nOil-based PU, conversion varnish, epoxy: rating 5; shellac, NC lacquer: rating 1–2"],
        ["Ethanol resistance","10% (wine) and 96% (spirits) exposure — most demanding stain test\nConversion varnish: resists 96% for 1h; water-based PU: resists 10% for 24h\nNC lacquer: dissolved by 96% ethanol immediately"],
        ["Abrasion resistance (EN 13329)","Taber abrasion (CS17 wheel, 1kg, 500 cycles) — report wear-through cycles\nFlooring PU: 10,000+ cycles; furniture lacquer: 1,000–3,000 cycles\nConversion varnish: 3,000–5,000 cycles under furniture test conditions"],
        ["Heat resistance (BS EN 12721)","Dry heat (glass beaker, 70°C/100°C); wet heat (glass ring + boiling water)\nRating 1–5 (5 = no change); kitchen surfaces: minimum rating 3 dry, 2 wet\nEpoxy and conversion varnish: class 4–5; NC lacquer: class 1–2"],
        ["UV / light fastness","Xenon arc weathering per ISO 11341 / BS 1006; grey scale rating\nExterior stains and UV-resistant varnishes: minimum 1,000 h to grey scale 4\nPigmented systems outperform clear coats — UV absorbers + HALS (hindered amine light stabilisers)"],
        ["Chemical resistance index","EN 12720 list includes: acetone, ethyl acetate, ammonia, detergent, tea, red wine\nMost demanding: acetone — only catalysed systems resist; shellac, NC: fail instantly\nTest programme for kitchen doors: 12 agents minimum per EN 438-2 for high-pressure laminate comparison"],
        ["Pencil hardness (ISO 15184)","Scratch hardness using calibrated pencils 6B to 9H\nNC lacquer: typically 2H–3H; 2K PU: 4H–5H; UV cure: 5H–6H\nNot a wear predictor — only a surface hardness indication"],
      ]}/>

      <h2 style={S.h2}>Health, Safety &amp; Environmental Compliance</h2>
      <Table2 rows={[
        ["VOC emissions (EU Dir. 2004/42/EC)","Category WB (wood coating): 150 g/L water-based; 400 g/L solvent-based maximum\nSB (SB decorative): up to 400 g/L; speciality lacquers: 600 g/L (derogation)\nSolvent-based conversion varnish: typically 380–450 g/L before thinning"],
        ["Isocyanate hazards (2K PU)","MDI/HDI hardeners are respiratory sensitisers — irreversible asthma risk\nControl measures: enclosed spray booth + air supply RPE (P3 + organic vapour)\nHSE EH40 WEL: TDI 0.02 mg/m³ TWA; monitoring required on production lines"],
        ["HAPs (hazardous air pollutants)","Toluene, xylene, MEK in solvent-based finishes — listed as HAPs in US (40 CFR Part 63)\nSubstitution to compliant coatings or air-capture abatement required above de minimis thresholds\nAutomatic spray booths: thermal oxidiser for solvent destruction"],
        ["Spray booth requirements","Cross-draft or downdraft; air velocity 0.3–0.5 m/s at work face; ATEX zone 2\nFire suppression, explosion-proof motors, earthing for electrostatic\nFilter efficiency: dry filters G4 + F8 standard; water wash for high-build"],
        ["REACH compliance","Restriction of Hazardous Substances in chemical products sold in EU\nSVHC (substances of very high concern) must be declared at >0.1% concentration\nFormaldehyde from amino-alkyd systems: subject to REACH SVHC listing"],
        ["Waste disposal","Solvents: collect for solvent recovery plant or licensed waste disposal\nAqueous waste (water-based): flocculation/pH adjust before drain discharge\nSolid waste (paint sludge): hazardous waste — manifested disposal required"],
        ["Oily rag fire risk","Tung oil, linseed oil rags self-ignite — exothermic oxidation on large surface area\nImmediate action: submerge in water in sealed metal container; dispose same day\nSeveral fatal workshop fires attributed to discarded oil-soaked rags"],
      ]}/>

      <InfoBox title="Key Formulae &amp; Reference Values" items={[
        "DFT = WFT × (volume solids% / 100)   [wet film thickness × volume solids fraction]",
        "Spreading rate = 1,000,000 × volume solids% / (DFT µm × 100)   [m²/L at target DFT]",
        "VOC content (g/L) = mass of VOC solvents / total volume of mixed coating",
        "Transfer efficiency (%) = mass deposited on substrate / mass sprayed × 100",
        "Gloss (GU): measured at 60° per ISO 2813; 20° for >70 GU; 85° for <10 GU",
        "Pot life (2K systems): approximately halved for every 10°C rise in temperature",
        "Dry film thickness gauge: eddy-current (non-ferrous substrates) per ISO 2360; ultrasonic for wood per ISO 2808",
        "Inter-coat adhesion test: cross-cut tape test ISO 2409 — require rating 0 (0% removal) for production release",
        "Open time (water-based): 5–20 min at 20°C / 50% RH — reduce by 50% at 30°C or in a draught",
        "Viscosity: Ford cup #4 — 18–30 s for most spray finishes; Zahn cup for high-build systems",
      ]}/>
    </div>
  );
}